import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExaminationComponent } from './examination/examination.component';
import { DataCheckComponent } from 'app/examination/data-check/data-check.component';
import { WorkprocessComponent } from 'app/examination/workprocess/workprocess/workprocess.component';
import { ResultComponent } from './result/result.component';
import { FirstAssessorSigningComponent } from './first-assessor-signing/first-assessor-signing.component';
import { SecondAssessorSigningComponent } from './second-assessor-signing/second-assessor-signing.component';
import { StudentSigningComponent } from './student-signing/student-signing.component';
import { AuthGuardService } from 'app/auth-guard.service';

const routes: Routes = [
  {
    path: 'students/:studentIdEncrypted/:creboId/crebos/examination/:examinationId',
    component: ExaminationComponent,
    children: [
      {
        path: 'workprocess/:workprocessId',
        component: WorkprocessComponent
      },
      {
        path: 'data-check',
        component: DataCheckComponent,
      },
      {
        path: 'result',
        component: ResultComponent,
        children: [
          {
            path: '',
            component: FirstAssessorSigningComponent
          },
          {
            path: 'second-assessor-signing',
            component: SecondAssessorSigningComponent
          },
          {
            path: 'second-assessor-signing/:batch',
            component: SecondAssessorSigningComponent
          },
          {
            path: 'student-signing',
            component: StudentSigningComponent
          }
        ],
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService]
      }
    ],
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExaminationRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/examination/examination-routing.module.ts